import Emitter from 'tiny-emitter'; //import emitter from 'tiny-emitter/instance';

class EventBus {
  constructor() {
    this._emitter = new Emitter();
    this._data = {};
  }

  $on() {
    return this._emitter.on(...arguments);
  }

  $off() {
    return this._emitter.off(...arguments);
  }

  $emit() {
    return this._emitter.emit(...arguments);
  }

  $once() {
    return this._emitter.once(...arguments);
  }

  isCtrlPressed(e) {
    if (e.ctrlKey || e.metaKey || e.keyCode == 91) {
      return this._data.is_ctrl_pressed = true;
    } else {
      return this._data.is_ctrl_pressed = false;
    }
  }

  isShiftPressed(e) {
    if (e.shiftKey) {
      return this._data.is_shift_pressed = true;
    } else {
      return this._data.is_shift_pressed = false;
    }
  }

}

;
const SuccessFail = {
  Success: "",
  Fail: ""
};
const events = {
  Navigation: {
    PageChanged: ""
  },
  Body: {
    Click: ""
  },
  Window: {
    Resize: ""
  },
  User: {
    Login: { ...SuccessFail
    },
    Register: { ...SuccessFail
    },
    Auth: { ...SuccessFail
    },
    Change: { ...SuccessFail
    },
    Session: {
      Change: ""
    }
  },

  defineEvents(obj, name) {
    const f = (o, e) => {
      Object.keys(o).forEach(objKey => {
        const v = o[objKey];

        if (typeof v == "object") {
          f(v, e[objKey] || (e[objKey] = {}));
        } else {
          e[objKey] = v;
        }
      });
    };

    f(obj, events);
    createNamedValues(events, name);
  }

};

function createNamedValues(obj, predefinedKey) {
  Object.keys(obj).forEach(objKey => {
    let val = obj[objKey];
    let stringValue = [predefinedKey, objKey].join(".");

    if (typeof val == "object") {
      createNamedValues(val, stringValue);
    } else {
      if (val == '') {
        obj[objKey] = stringValue;
      }
    }
  });
  return obj;
}

;
export const EVENTS = createNamedValues(events, "EVENTS");
export const eventBus = new EventBus();